var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.spanClass,attrs:{"disabled":_vm.spanDisabled || (_vm.showLoading && _vm.isLoading)},on:{"click":_vm.handleClick}},[(_vm.showLoading && _vm.isLoading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }